export default {
  name: 'VShow',
  components: {},
  props: {
    interfaceDetail: Object
  },
  data() {
    return {
      isShow: true
    };
  },
  computed: {},
  mounted() {},
  methods: {
    clickImg() {
      this.isShow = !this.isShow;
    }
  },
  watch: {}
};